export default __webpack_public_path__ + "static/media/SecondConnect.b0888cc6.png";